<template>
  <div>
    <DataTable
      title="משימות בטיפול כעת"
      :show_delete="false"
      :show_edit="false"
      :show_header_filter="false"
      :operations="operations"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :response="data"
      @create="createAlert"
      @info="showStatInfo"
       />
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'InProgress',
  components: {
    DataTable
  },
  data () {
    return {
      fields: [
        {
          name: 'owner',
          value: 'owner',
          component: 'TableCellOwner'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'duration',
          component: 'TableCellDuration'
        },
        {
          name: 'resources',
          component: 'TableCellLiteResources'
        }
      ],
      sorters: [
        {
          designator: 'owner',
          value: '-owner'
        },
        {
          designator: 'priority',
          value: '-priority'
        },
        {
          designator: 'timing',
          value: '-timing'
        }
      ],
      filters: [
        {
          type: 'multiple',
          designator: 'designators',
          options: this.designatorOptions
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        }
      ],
      data: [],
      operations: [{ name: 'info', icon: '/info.svg' }]
    }
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('feedDesignators', ['feedDesignators', 'designatorOptions'])
  },
  watch: {
    dropdownAdmins (oldValue, newValue) {
      this.filters.forEach((filter) => {
        if (filter.designator === 'owner') {
          filter.options = newValue
        }
      })
    },
    designatorOptions (oldValue, newValue) {
      this.filters.forEach((filter) => {
        if (filter.designator === 'designators') {
          filter.options = newValue
        }
      })
    }
  },
  created () {
    this.getAlerts()
    this.fetchAll()
  },
  mounted () {
    document.title = 'משימות בטיפול כעת'
  },
  methods: {
    getAlerts () {
      this.$network_utils
        .getAllAlerts({
          page: this.$route.query.page || 1,
          per: 100,
          statuses: this.$route.query.statuses,
          sort: this.$route.query.sort,
          owner: this.$route.query.owner
        })
        .then((response) => {
          this.data = response
        })
    },
    createAlert () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        modal_title: 'Create new Item'
      })
    },
    showStatInfo (data) {
      if (!data.owner) {
        alert('Sorry, no owner exist for this alert.')
        return
      }
      this.create({
        designator: 'alert-form-modal',
        component_name: 'ModalAdminInProgress',
        modal_title: `${data.owner} alert's`,
        props: {
          owner: data.owner
        }
      })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapMutations('modals', ['create'])
  }
}
</script>
